import { useEffect } from 'react';

/**
 * .modal-backdrop / .modal / .modal-footer.
 *
 * Adds the three things the hand-rolled version in public/index.html never had:
 * Escape closes it, a backdrop click closes it, and body scroll is locked while
 * it is open. All three are expected of a dialog and none of them are themed, so
 * they cost nothing to get right once.
 */
export default function Modal({ open, title, onClose, footer, width = 440, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = e => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="modal-backdrop open"
      onMouseDown={e => { if (e.target === e.currentTarget) onClose?.(); }}
      role="presentation"
    >
      {/* Width is a per-dialog decision, so it comes in as a custom property the
          stylesheet consumes — see .modal in legacy.css and common.css. */}
      <div className="modal" style={{ '--modal-width': typeof width === 'number' ? `${width}px` : width }}
           role="dialog" aria-modal="true" aria-label={title}>
        {title && <h3>{title}</h3>}
        {children}
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
